import { Field, FieldMetaDataOption } from 'module/api/field/types';
import { SimpleSearchFilter } from 'module/api/filter/types';
import { User } from 'module/api/user/types';
import { PageType, SourceType } from 'api/page-template/types';
import { DetectedSignal, SignalOccurrence } from 'api/timeline/types';

export enum CustomSectionNodeType {
  RlCustomSection = 'RL_CUSTOM_SECTION',
  RlGroupSection = 'RL_GROUP_SECTION',
  RlGroupedSectionTemp = 'RL_GROUPED_SECTION_TEMP',
}
export enum CustomSectionType {
  Question = 'QUESTION',
  Action = 'ACTION',
  ExtractInfo = 'EXTRACT_INFO',
  MeetingDetails = 'MEETING_DETAILS',
  AccountDetails = 'ACCOUNT_DETAILS',
  SignalDetails = 'SIGNAL_DETAILS',
  CompanyPageSourceDerivedSection = 'COMPANY_PAGE_SOURCE_DERIVED_SECTION',
  CustomTextSection = 'CUSTOM_TEXT_SECTION',
  PeoplePageSourceDerivedQuestionSection = 'PEOPLE_PAGE_SOURCE_DERIVED_QUESTION_SECTION',
  PeoplePageSourceDerivedSignalSection = 'PEOPLE_PAGE_SOURCE_DERIVED_SIGNAL_SECTION',
  EmailDetails = 'EMAIL_DETAILS',
  MultiQuestion = 'MULTI_QUESTION',
  QuestionAnswerItem = 'QUESTION_ANSWER_ITEM',
  TableDetails = 'TABLE',
  RecordBlock = 'RECORD',
}
export enum CustomSectionState {
  Open = 'open',
  Closed = 'closed',
}
export enum CustomSectionContentState {
  Prompt = 'PROMPT',
  Generated = 'GENERATED',
}
export enum GroupByOption {
  Topics = 'TOPICS',
  Company = 'COMPANY',
  Participants = 'PARTICIPANTS',
  TimePeriod = 'TIME_PERIOD',
  None = 'NONE',
}
export enum GenerateAsOption {
  Paragraph = 'PARAGRAPH',
  Bullet = 'BULLET',
  Number = 'NUMBER',
  Table = 'TABLE',
  Checklist = 'CHECKLIST',
  Task = 'TASK',
}
export enum ParticipantGroupOption {
  All = 'ALL',
  CustomerParticipants = 'CUSTOMER_PARTICIPANTS',
  MyTeam = 'MY_TEAM',
  // SeniorCustomerParticipants = 'SENIOR_CUSTOMER_PARTICIPANTS',
  Custom = 'CUSTOM',
}

export type SourcePageTemplate = {
  pageType: PageType;
  sourceType: SourceType;
  templateId: number;
  templateName: string;
};

export type CustomNodeResponseFieldValueType =
  | boolean
  | number
  | string
  | FieldMetaDataOption<number>
  | FieldMetaDataOption<number>[]
  | User
  | User[]
  | DetectedSignal[]
  | SignalOccurrence[];
export type CustomNodeResponseField = Field & {
  fieldValue: CustomNodeResponseFieldValueType;
};
export type CustomNodeFieldConfigResponse = Record<
  string,
  CustomNodeResponseFieldValueType
> & {
  fields: CustomNodeResponseField[];
};

export type BaseCustomSectionAttributes = {
  contentState: CustomSectionContentState;
  contentEditable?: boolean;
  state?: CustomSectionState;
  templateSectionId?: string;
  documentSectionId?: string;
  tempId?: string;
  title: string;
  filters?: {
    dynamicCondition?: SimpleSearchFilter;
  };
  isTableStatic?: boolean;
};
